// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DescriptorCreate } from "./DescriptorCreate";
import {
  DescriptorCreateFromJSON,
  DescriptorCreateFromJSONTyped,
  DescriptorCreateToJSON,
  DescriptorCreateToJSONTyped,
} from "./DescriptorCreate";

/**
 *
 * @export
 * @interface UploadComplete
 */
export interface UploadComplete {
  /**
   *
   */
  id: string;
  /**
   *
   */
  branch: string;
  /**
   *
   */
  transactionId: string;
  /**
   *
   */
  address: string;
  /**
   * Use descriptor.data_type instead
   */
  dataType?: string | null;
  /**
   *
   */
  descriptor?: DescriptorCreate;
  /**
   *
   */
  message?: string | null;
}

/**
 * Check if a given object implements the UploadComplete interface.
 */
export function instanceOfUploadComplete(value: object): value is UploadComplete {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (!("branch" in value) || value["branch"] === undefined) return false;
  if (
    (!("transactionId" in (value as Record<string, any>)) &&
      !("transaction_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["transactionId"] === undefined &&
      (value as Record<string, any>)["transaction_id"] === undefined)
  )
    return false;
  if (!("address" in value) || value["address"] === undefined) return false;
  return true;
}

export function UploadCompleteFromJSON(json: any): UploadComplete {
  return UploadCompleteFromJSONTyped(json, false);
}

export function UploadCompleteFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UploadComplete {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    branch: json["branch"],
    transactionId: json["transaction_id"],
    address: json["address"],
    dataType:
      json["data_type"] === undefined
        ? undefined
        : json["data_type"] === null
        ? null
        : json["data_type"],
    descriptor:
      json["descriptor"] == null ? undefined : DescriptorCreateFromJSON(json["descriptor"]),
    message:
      json["message"] === undefined ? undefined : json["message"] === null ? null : json["message"],
  };
}

export function UploadCompleteToJSON(json: any): UploadComplete {
  return UploadCompleteToJSONTyped(json, false);
}

export function UploadCompleteToJSONTyped(
  value?: UploadComplete | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    branch: value["branch"],
    transaction_id: value["transactionId"],
    address: value["address"],
    data_type: value["dataType"],
    descriptor: DescriptorCreateToJSON(value["descriptor"]),
    message: value["message"],
  };
}
